import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=10beccc4&scoped=true&"
import script from "./PaymentMethod.js?vue&type=script&lang=js&"
export * from "./PaymentMethod.js?vue&type=script&lang=js&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=10beccc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10beccc4",
  null
  
)

export default component.exports